(function () {
  var HEADER_SLOT = '[data-header-wishlist]';
  var placing = false;
  var HEADER_HEART_PATH =
    'M12.4869 22C12.2364 21.9968 11.9918 21.9232 11.7804 21.7875C8.18822 19.57 5.48518 17.3766 3.2783 14.8705C2.01853 13.5287 1.04215 11.942 0.408559 10.207C-0.730606 6.84675 0.5832 2.9211 3.46882 1.07256C4.78425 0.221399 6.35422-0.134962 7.90363 0.0659208C9.45304 0.266804 10.8831 1.01212 11.9431 2.17126C12.1376 2.37977 12.3162 2.60031 12.4869 2.81685C12.7194 2.51694 12.97 2.2317 13.2371 1.96275C13.8816 1.32075 14.6473 0.816306 15.4888 0.479444C16.3303 0.142583 17.2302-0.0198119 18.1351 0.00192686C19.0214 0.0266866 19.8936 0.23235 20.6992 0.606539C21.5048 0.980728 22.2271 1.51571 22.8227 2.17928C25.0693 4.63732 25.6012 7.62065 24.3072 10.8045C23.6255 12.404 22.6611 13.8647 21.4613 15.1151C19.3548 17.3836 16.9713 19.3724 14.3683 21.0336C14.019 21.2662 13.6578 21.4907 13.3006 21.7113L13.1934 21.7795C12.9825 21.9174 12.738 21.9937 12.4869 22Z';
  var HEADER_HEART_HTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="24" viewBox="0 0 24 24" fill="none" class="icon" aria-hidden="true" data-netsteps-header-heart="2">' +
    '<path d="' +
    HEADER_HEART_PATH +
    '" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
    '</svg>';

  function wishlistLabel() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('el') === 0 ? 'Αγαπημένα' : 'Wishlist';
  }

  function isEmptyCount(count) {
    var total = count.getAttribute('data-total');
    var text = (count.textContent || '').replace(/\s/g, '');
    return total === '0' || text === '0' || text === '';
  }

  function syncCount(icon) {
    var count = icon.querySelector('.wishlist-h-count, .wishlist-total-count');
    if (!count) return;
    count.classList.toggle('is-empty', isEmptyCount(count));
  }

  function watchCount(icon) {
    var count = icon.querySelector('.wishlist-h-count, .wishlist-total-count');
    if (!count || count.dataset.wishlistCountWatch === 'true') return;
    count.dataset.wishlistCountWatch = 'true';
    syncCount(icon);
    new MutationObserver(function () {
      syncCount(icon);
    }).observe(count, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-total']
    });
  }

  function headerIcons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('a.h-wishlist-icon, a.wishlist-page-widget')
    );
  }

  function normalizeHeaderIcon(icon) {
    if (!icon) return;

    icon.classList.add('icon', 'header__icon', 'unstyled-link');
    icon.style.removeProperty('width');
    icon.style.removeProperty('height');
    icon.style.removeProperty('font-size');
    icon.style.removeProperty('transform');
    icon.style.removeProperty('scale');

    icon.querySelectorAll('svg:not([data-netsteps-header-heart="2"])').forEach(function (node) {
      node.remove();
    });

    icon.querySelectorAll('.wishlist-h-count, .wishlist-total-count').forEach(function (node) {
      node.remove();
    });

    if (icon.querySelector('svg[data-netsteps-header-heart="2"]')) return;

    var wrap = document.createElement('div');
    wrap.innerHTML = HEADER_HEART_HTML;
    icon.insertBefore(wrap.firstElementChild, icon.firstChild);
  }

  function placeHeaderIcon() {
    var slot = document.querySelector(HEADER_SLOT);
    if (!slot) return;

    var icons = headerIcons();
    var icon = slot.querySelector('a.h-wishlist-icon, a.wishlist-page-widget') || icons[0];
    if (!icon) return;

    if (icon.parentElement !== slot) slot.appendChild(icon);

    icons.forEach(function (extra) {
      if (extra === icon) return;
      extra.style.setProperty('display', 'none', 'important');
    });

    if (!icon.getAttribute('aria-label')) {
      icon.setAttribute('aria-label', wishlistLabel());
    }

    normalizeHeaderIcon(icon);
  }

  function pdpTarget() {
    var title = document.querySelector('.product__info h1');
    if (!title) return null;
    var row = title.parentElement;
    row.classList.add('pdp-title-row');
    return row;
  }

  function placePdpHeart() {
    var target = pdpTarget();
    if (!target) return;

    var hearts = Array.prototype.slice.call(
      document.querySelectorAll('.product__info .wishlist-engine, .product-mobile-media > .wishlist-engine, .product-desktop-media > .wishlist-engine')
    );
    if (!hearts.length) return;

    var incoming = hearts.filter(function (node) {
      return node.parentElement !== target;
    })[0];
    var heart = incoming || hearts[0];

    hearts.forEach(function (node) {
      if (node !== heart) node.remove();
    });

    if (heart.parentElement !== target) target.appendChild(heart);
    heart.classList.add('pdp-wishlist-heart');
  }

  function placeAll() {
    if (placing) return;
    placing = true;
    try {
      placeHeaderIcon();
      placePdpHeart();
      enhanceWishlistSizes();
    } finally {
      placing = false;
    }
  }

  var observer = new MutationObserver(placeAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAll);
  } else {
    placeAll();
  }

  window.addEventListener('resize', placePdpHeart);
  document.addEventListener('shopify:section:load', placeAll);
  watchWishlistCartAdds();
})();

function watchWishlistCartAdds() {
  if (window.netstepsWishlistCartWatch) return;
  window.netstepsWishlistCartWatch = true;

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function refreshThemeCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.dataset.sectionId) return;

    var sectionId = drawer.dataset.sectionId;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') root += '/';

    Promise.all([
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
        return response.json();
      }),
      fetch(root + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' }).then(function (response) {
        return response.json();
      })
    ])
      .then(function (results) {
        var cart = results[0];
        var sections = results[1];
        var htmlString = sections[sectionId];
        if (!htmlString) return;

        var doc = new DOMParser().parseFromString(htmlString, 'text/html');
        var added = cart.items && cart.items[0];

        if (typeof drawer.purchaseHandler === 'function') {
          drawer.purchaseHandler(doc, added);
        }

        var newCount = doc.querySelector('#NewCartCount');
        if (newCount) {
          document.querySelectorAll('#CartCount').forEach(function (node) {
            node.innerHTML = newCount.innerHTML;
          });
        }

        if (typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('.wishlist-size-select');
    if (!select) return;
    applyWishlistSize(select);
  });

  document.addEventListener('click', function (event) {
    var move = event.target.closest && event.target.closest('.wishlist-move-cart');
    if (!move) return;
    var column = move.closest('.wishlist-column');
    if (!column) return;
    var select = column.querySelector('.wishlist-size-select');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var variantId = select.value;
    if (!variantId || (option && option.dataset.unavailable === 'true')) {
      event.preventDefault();
      event.stopPropagation();
      if (!variantId) {
        showWishlistSizeRequired(column, select);
      } else {
        clearWishlistSizeError(select);
        select.focus();
      }
      return;
    }
    clearWishlistSizeError(select);
    move.setAttribute('data-variant_id', variantId);
    window.__netstepsWishlistVariant = variantId;
  }, true);

  function rewriteCartBody(body) {
    var variantId = window.__netstepsWishlistVariant;
    if (!variantId || body == null) return body;
    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === '{') {
        try {
          var json = JSON.parse(body);
          if (json.id) json.id = Number(variantId);
          if (json.items && json.items[0]) json.items[0].id = Number(variantId);
          return JSON.stringify(json);
        } catch (error) {
          return body;
        }
      }
      var params = new URLSearchParams(body);
      if (params.has('id')) {
        params.set('id', variantId);
        return params.toString();
      }
      return body;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData && body.has('id')) {
      body.set('id', variantId);
    }
    return body;
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (isCartAdd(url) && init && init.body) {
      init = Object.assign({}, init, { body: rewriteCartBody(init.body) });
    }
    var pending = nativeFetch.call(this, input, init);
    if (isCartAdd(url)) {
      pending.then(function (response) {
        if (response && response.ok) {
          window.__netstepsWishlistVariant = null;
          window.setTimeout(refreshThemeCart, 60);
        }
      }).catch(function () {});
    }
    return pending;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__netstepsCartUrl = url;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (isCartAdd(this.__netstepsCartUrl)) {
      body = rewriteCartBody(body);
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          window.__netstepsWishlistVariant = null;
          window.setTimeout(refreshThemeCart, 60);
        }
      });
    }
    return nativeSend.call(this, body);
  };
}

function enhanceWishlistSizes() {
  document.querySelectorAll('.wishlist-column').forEach(function (column) {
    if (column.dataset.wishlistSizesReady) return;
    var link = column.querySelector('.wishlist-top a');
    var button = column.querySelector('.wishlist-move-cart');
    if (!link || !button) return;
    var jsonUrl = productJsonUrl(link.getAttribute('href'));
    if (!jsonUrl) return;
    column.dataset.wishlistSizesReady = 'pending';
    fetch(jsonUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        renderWishlistSizes(column, button, product);
        column.dataset.wishlistSizesReady = 'true';
      })
      .catch(function () {
        delete column.dataset.wishlistSizesReady;
      });
  });
}

function productJsonUrl(href) {
  try {
    var url = new URL(href, window.location.origin);
    return url.pathname.replace(/\/$/, '') + '.js';
  } catch (error) {
    return '';
  }
}

function sizeOptionFor(product) {
  var options = product.options || [];
  var match = options.filter(function (option) {
    return /size|μέγεθος|μεγεθος/i.test(option.name || '');
  })[0];
  if (match) return match;
  if (options.length === 1) return options[0];
  return null;
}

function renderWishlistSizes(column, button, product) {
  var sizeOption = sizeOptionFor(product);
  if (!sizeOption || column.querySelector('.wishlist-sizes')) return;

  var currentId = String(button.getAttribute('data-variant_id') || '');
  var current = (product.variants || []).filter(function (variant) {
    return String(variant.id) === currentId;
  })[0];
  var position = sizeOption.position;
  var host = column.querySelector('.wishlist-advanced-option') || column.querySelector('.wihslist-meta');
  if (!host) return;

  var row = document.createElement('label');
  row.className = 'wishlist-sizes';

  var select = document.createElement('select');
  select.className = 'wishlist-size-select';
  select.setAttribute('aria-label', sizePrompt());

  var placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.textContent = sizePrompt();
  placeholder.disabled = true;
  placeholder.selected = true;
  select.appendChild(placeholder);

  sizeOption.values.forEach(function (value) {
    var variant = (product.variants || []).filter(function (item) {
      if (item['option' + position] !== value) return false;
      if (!current) return true;
      for (var index = 1; index <= 3; index += 1) {
        if (index === position) continue;
        if (current['option' + index] && item['option' + index] !== current['option' + index]) return false;
      }
      return true;
    })[0];

    var option = document.createElement('option');
    var unavailable = !variant || !variant.available;
    option.textContent = unavailable ? value + ' — ' + soldOutLabel() : value;
    if (unavailable) {
      option.disabled = true;
      option.value = '';
      option.dataset.unavailable = 'true';
    } else {
      option.value = String(variant.id);
    }
    select.appendChild(option);
  });

  row.appendChild(select);
  host.appendChild(row);
}

function sizePrompt() {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('el') === 0) return 'Μεγεθος';
  return 'Size';
}

function soldOutLabel() {
  return 'Sold out';
}

function sizeRequiredMessage() {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('el') === 0) return 'Παρακαλώ επιλέξτε πρώτα μέγεθος.';
  return 'Please select a size first.';
}

function showWishlistSizeRequired(column, select) {
  var row = column.querySelector('.wishlist-sizes');
  if (!row || !select) return;
  if (!column.dataset.wishlistSizeErrorId) {
    column.dataset.wishlistSizeErrorId = String(Math.random()).slice(2, 10);
  }
  var hintId = 'wishlist-size-error-' + column.dataset.wishlistSizeErrorId;
  row.classList.add('is-error');
  select.setAttribute('aria-invalid', 'true');
  select.setAttribute('aria-describedby', hintId);
  var hint = row.querySelector('.wishlist-size-error');
  if (!hint) {
    hint = document.createElement('span');
    hint.className = 'wishlist-size-error';
    hint.setAttribute('role', 'alert');
    row.appendChild(hint);
  }
  hint.id = hintId;
  hint.textContent = sizeRequiredMessage();
  select.focus();
}

function clearWishlistSizeError(select) {
  if (!select) return;
  var row = select.closest('.wishlist-sizes');
  if (!row) return;
  row.classList.remove('is-error');
  select.removeAttribute('aria-invalid');
  select.removeAttribute('aria-describedby');
  var hint = row.querySelector('.wishlist-size-error');
  if (hint) hint.textContent = '';
}

function applyWishlistSize(select) {
  var column = select.closest('.wishlist-column');
  var variantId = select.value;
  if (!column || !variantId) return;
  clearWishlistSizeError(select);
  var move = column.querySelector('.wishlist-move-cart');
  if (move) move.setAttribute('data-variant_id', variantId);
  column.querySelectorAll('a[href*="variant="]').forEach(function (anchor) {
    var url = new URL(anchor.href);
    url.searchParams.set('variant', variantId);
    anchor.href = url.toString();
  });
}
